// extracted by mini-css-extract-plugin
export var center = "_47-2";
export var clickableRow = "_47-5";
export var expandedRow = "_47-7";
export var hoverable = "_47-4";
export var left = "_47-1";
export var right = "_47-3";
export var row = "_47-0";
export var selectedRow = "_47-6";
export var summaryRow = "_47-8";